import React from 'react';
import { Container } from 'reactstrap';

import CollapsibleCard from '../../../CollapsibleCard';

import optimize from './assets/optimize.svg';
import identify from './assets/identify.svg';
import uncover from './assets/uncover.svg';

const ITEMS = [
  {
    stripeColor: 'blue',
    icon: optimize,
    title: 'Optimizing Workloads',
    text:
      'Parse out and re-architect your workloads to make them faster and more cost-effective.',
  },
  {
    stripeColor: 'orange',
    icon: identify,
    title: 'Identify Risks',
    text:
      'Gain deeper understanding of your current infrastructure so you can reduce risk as you scale.',
  },
  {
    stripeColor: 'dark-blue',
    icon: uncover,
    title: 'Uncover Opportunities',
    text:
      'Find new tools to help you build more efficiently and optimize as your business grows.',
  },
];

const BestPractices = () => {
  return (
    <section className="BestPractices">
      <Container>
        <h2 className="BestPractices__title">
          Shoring Up AWS&nbsp;
          <span className="text-dark-blue">Best Practices</span>
        </h2>

        <div className="BestPractices__lead">
          Cloudnexa performs Well-Architected Framework (WAF) reviews. These
          reviews generate action items that can be immediately applied to help
          infrastructure align with AWS best practices. The result is a faster,
          more secure infrastructure that costs less.
        </div>

        <div className="d-flex flex-column flex-md-row flex-md-wrap align-items-md-stretch">
          {ITEMS.map((item, idx) => (
            <div
              className="w-100 w-md-50 w-lg-33 mb-3 mb-lg-0 pl-md-2 pr-md-2"
              key={idx}
            >
              <CollapsibleCard
                {...item}
                isOpenDefault={idx === 0}
                className="CollapsibleCard--bg-offwhite"
              >
                {item.text}
              </CollapsibleCard>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default BestPractices;
